import theme, { gsap, _, $, ScrollTrigger, CSSRulePlugin, ScrollToPlugin} from "./main"

theme.on('load', function () {
    console.debug("Theme loading....");
})

theme.on('loaded', function () {
    console.debug("Theme loaded.");

    $('.app').addClass('loaded');
});